import parse from 'html-react-parser'
import sanitizeHtml from 'sanitize-html';

export const safeHtml = (html) => {
    return (<>{parse(sanitizeHtml(html))}</>);
}